__turbopack_context__.v({
  "body": "CAdvertisements-module__JMmE-q__body",
  "card": "CAdvertisements-module__JMmE-q__card",
  "cardLink": "CAdvertisements-module__JMmE-q__cardLink",
  "cardTitle": "CAdvertisements-module__JMmE-q__cardTitle",
  "empty": "CAdvertisements-module__JMmE-q__empty",
  "fieldsGrid": "CAdvertisements-module__JMmE-q__fieldsGrid",
  "form": "CAdvertisements-module__JMmE-q__form" + " " + __turbopack_context__.i("[project]/components/ui/Form/Form.module.css [app-client] (css module)")["form"],
  "formActions": "CAdvertisements-module__JMmE-q__formActions",
  "gridSpan2": "CAdvertisements-module__JMmE-q__gridSpan2",
  "leafLink": "CAdvertisements-module__JMmE-q__leafLink",
  "list": "CAdvertisements-module__JMmE-q__list",
  "meta": "CAdvertisements-module__JMmE-q__meta",
  "metaItem": "CAdvertisements-module__JMmE-q__metaItem",
  "metaLabel": "CAdvertisements-module__JMmE-q__metaLabel",
  "more": "CAdvertisements-module__JMmE-q__more",
  "nodeCount": "CAdvertisements-module__JMmE-q__nodeCount",
  "nodeName": "CAdvertisements-module__JMmE-q__nodeName",
  "parentLink": "CAdvertisements-module__JMmE-q__parentLink",
  "resultsSection": "CAdvertisements-module__JMmE-q__resultsSection",
  "resultsTitle": "CAdvertisements-module__JMmE-q__resultsTitle",
  "root": "CAdvertisements-module__JMmE-q__root",
  "searchSection": "CAdvertisements-module__JMmE-q__searchSection",
  "searchTitle": "CAdvertisements-module__JMmE-q__searchTitle",
  "teaser": "CAdvertisements-module__JMmE-q__teaser",
  "thumb": "CAdvertisements-module__JMmE-q__thumb",
  "thumbWrap": "CAdvertisements-module__JMmE-q__thumbWrap",
  "tree": "CAdvertisements-module__JMmE-q__tree",
  "treeChildren": "CAdvertisements-module__JMmE-q__treeChildren",
  "treeNode": "CAdvertisements-module__JMmE-q__treeNode",
  "treeSection": "CAdvertisements-module__JMmE-q__treeSection",
  "treeTitle": "CAdvertisements-module__JMmE-q__treeTitle",
});
